import { Container, Title, Text, Stack, Divider, Anchor } from '@mantine/core';

export default function PrivacyPolicy() {
  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Title order={1}>Privacy Policy</Title>
        <Text c="dimmed" size="sm">Last updated: April 11, 2026</Text>

        <Divider />

        <Title order={3}>1. Introduction</Title>
        <Text>
          Standard Produce Company ("we", "us", "our") operates the customer portal
          at portal.standardproduce.com and related services. This Privacy Policy describes
          how we collect, use, and protect information from our business-to-business (B2B)
          customers and website visitors.
        </Text>

        <Title order={3}>2. Information We Collect</Title>
        <Text>
          We collect information you provide directly when creating an account or placing
          orders, including: business name, contact name, email address, phone number,
          delivery address, tax ID, and payment information. We also collect order history,
          delivery records, and communication preferences.
        </Text>

        <Title order={3}>3. How We Use Your Information</Title>
        <Text>
          We use your information to: process and fulfill orders, send order confirmations
          and delivery updates, provide account balance and invoice notifications, manage
          your account and credit terms, communicate about service changes, and comply
          with legal obligations.
        </Text>

        <Title order={3}>4. SMS/Text Messaging</Title>
        <Text>
          If you opt in to our SMS service, we may send you order confirmations, delivery
          status updates, account balance notifications, and responses to your text
          commands. Message frequency varies (typically 2-10 messages per week for active
          accounts). Message and data rates may apply. You can opt out at any time by
          texting STOP, and text HELP for assistance. See our{' '}
          <Anchor href="/sms-terms" inherit>SMS Terms of Service</Anchor> for full details.
        </Text>
        <Text>
          <Text component="span" fw={600}>Mobile information sharing:</Text> No mobile
          information, including phone numbers and SMS opt-in data, will be shared with
          third parties or affiliates for marketing or promotional purposes. This category
          of personal information will not be shared with any third parties under any
          circumstances for marketing or promotional use.
        </Text>

        <Title order={3}>5. Information Sharing</Title>
        <Text>
          We do not sell your personal information. We share information only with: service
          providers who assist our operations (payment processors, delivery logistics,
          cloud hosting), and as required by law or to protect our legal rights. Mobile
          phone numbers and SMS opt-in data are excluded from all sharing with third
          parties and affiliates for marketing or promotional purposes (see Section 4).
        </Text>

        <Title order={3}>6. Data Security</Title>
        <Text>
          We implement industry-standard security measures including encryption in transit
          (TLS 1.3) and at rest (AES-256), role-based access controls, and regular security
          audits. Our infrastructure is hosted on AWS with SOC 2 compliant practices.
        </Text>

        <Title order={3}>7. Data Retention</Title>
        <Text>
          We retain account and order data for the duration of our business relationship
          and as required by law (typically 7 years for financial records). You may request
          deletion of your data by contacting us, subject to legal retention requirements.
        </Text>

        <Title order={3}>8. Your Rights</Title>
        <Text>
          You may request access to, correction of, or deletion of your personal information
          by contacting us at privacy@standardproduce.com or calling (434) 204-2184.
        </Text>

        <Title order={3}>9. Changes to This Policy</Title>
        <Text>
          We may update this policy from time to time. We will notify active customers of
          material changes via email or account notification.
        </Text>

        <Title order={3}>10. Contact Us</Title>
        <Text>
          Standard Produce Company{'\n'}
          Charlottesville, VA{'\n'}
          Phone: (434) 204-2184{'\n'}
          Email: privacy@standardproduce.com
        </Text>
      </Stack>
    </Container>
  );
}
